import { render, staticRenderFns } from "./SwapSwappedStep.vue?vue&type=template&id=08a026a2&scoped=true"
import script from "./SwapSwappedStep.vue?vue&type=script&lang=ts"
export * from "./SwapSwappedStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapSwappedStep.vue?vue&type=style&index=0&id=08a026a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a026a2",
  null
  
)

export default component.exports